import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';
import ListItem from 'components/notification/index/list_item';

const Index = ({ notifications, loading, unreadOnly }) => {
  return (
    <List disablePadding>
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {notifications.notifications.map((notification) => (
          <ListItem key={notification.id} notification={notification} />
        ))}
      </LoaderContainer>
      {!loading && notifications.notifications.length === 0 && (
        <IndexListItem>
          <InfoContainer>
            <FormattedMessage
              id={unreadOnly ? 'notification.empty.unread' : 'notification.empty'}
            />
          </InfoContainer>
        </IndexListItem>
      )}
    </List>
  );
};

export default Index;
